import svgUrl from "ni:svgr;HBFDcLuqtn4UOpeLYssSv5nUWnSdmBL5JjdLqb5eILM";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const MergeColumnsLIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none" viewBox="0 0 32 32" {...props}><path fill="var(--tbl--colors--icons--clean--primary)" fillRule="evenodd" d="M13 3a1 1 0 0 1 1 1v24a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1Zm7 0a1 1 0 0 1 1 1v24a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1ZM5.617 13.076a1 1 0 0 1 1.09.217l2 2a1 1 0 0 1 0 1.414l-2 2A1 1 0 0 1 5 18v-4a1 1 0 0 1 .617-.924Zm21.266 0a1 1 0 0 0-1.09.217l-2 2a1 1 0 0 0 0 1.414l2 2A1 1 0 0 0 27.5 18v-4a1 1 0 0 0-.617-.924Z" clipRule="evenodd" /></svg>;
const Memo = memo(MergeColumnsLIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "MergeColumnsLIcon";
}